module.exports = __webpack_public_path__ + "img/alpha-b-circle-outline.7a4f9e7.svg";